import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import PrecisionVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import PrecisionApi from './api/PrecisionApi';
import GeorasterApi from "./api/georasterApi";
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module";
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import AssetsModule from "@abaco/assets-module/src/modules/assets-module/index";
import ActivitiesModule from "@abaco/activities-module/src/modules/activities-module/index";
import PortalGlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";
import Vue from "vue";
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";

export const MODULE_ID = "precision_module";

export default class PrecisionModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private precisionApi!: PrecisionApi;
    private grstApi!: GeorasterApi;
    private apiCreated = false;

    private router!: VueRouter;
    private http!: HTTPClient;
    private ssoModule!: SSOModule;

    public tag!: string;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new PrecisionVuexModule();
    menu: MenuItem[] = [];
    private precisionBus!: Vue;

    constructor() {
        this.precisionBus = new Vue();
    }
    public getPrecisionBus() {
        return this.precisionBus;
    }
    dependsOn = {
        [PortalGlobalStateModule.MODULE_ID]: () => new PortalGlobalStateModule(),
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmRegistryModule.MODULE_ID]: () => new FarmRegistryModule(),
        [AssetsModule.MODULE_ID]: () => new AssetsModule(),
        [ActivitiesModule.MODULE_ID]: () => new ActivitiesModule()
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    /*
    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }
    */
    async onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }

        this.ssoModule = ssoModule;
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const PrecisionApi = (await import("./api/PrecisionApi")).default;
        this.precisionApi = new PrecisionApi(http);
        const georasterUrl = await this.precisionApi.getGeorasterExternalUrl();
        const GeorasterApiFile = (await import("./api/georasterApi")).default;
        this.grstApi = new GeorasterApiFile(georasterUrl, http);
         
        this.tag = await this.precisionApi.getGeorasterTag();
    }

    public async checkCompetences() {
        const res = await this.ssoModule.competenceResources.checkBulkCompetencesForUser(
            [
                { software: "MODELS_AND_MAPS", module: "LOAD_RASTER" }
            ]
        );

        this.vuexModule.canLoadRaster = res["MODELS_AND_MAPS|LOAD_RASTER"];
    }

    public get PrecisionApi(){
        return this.precisionApi;
    }

    public get georasterApi(){
        return this.grstApi;
    }

}
